<template>
  <section class="fixed right-10 top-32 z-20 mobile:inset-x-3 mobile:top-3">
    <div
      v-for="(notification, index) in notifications"
      :key="notification.id"
      class="relative mb-5 rounded-lg p-5 pr-14 mobile:!pr-10"
      :data-testid="`notification__${notification.type}-${index}`"
      :class="[colorClass(notification.type)]"
    >
      <header>
        <SfButton
          square
          variant="tertiary"
          class="absolute right-2 top-2"
          :class="[colorButton(notification.type)]"
          @click="notification.dismiss"
        >
          <SfIconClose />
        </SfButton>
      </header>
      <div class="flex max-w-96 gap-2">
        <KikIcon
          v-if="notification.icon"
          :icon="notification.icon"
          :class="[colorIcon(notification.type)]"
          size="xl"
          class="!size-[28px] min-w-[28px] mobile:!size-[34px]"
        />
        <div
          class="leading-6"
          :class="{ hidden: !notification.message }"
          v-html="$t(notification.message)"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { SfButton, SfIconClose } from '@storefront-ui/vue';
import useUiNotification from '~/composables/useUiNotification';

const { notifications } = useUiNotification();

const colorClass = (type: 'danger' | 'success' | 'info' | 'warning') => {
  switch (type) {
    case 'info':
      return 'bg-secondary-100 border border-secondary-200';
    case 'success':
      return 'bg-positive-100 border border-positive-200';
    case 'warning':
      return 'bg-warning-100 border border-warning-200';
    case 'danger':
      return 'bg-negative-100 border border-negative-200';
    default:
      return 'bg-positive-100 border border-positive-200';
  }
};

const colorIcon = (type: 'danger' | 'success' | 'info' | 'warning') => {
  switch (type) {
    case 'info':
      return '!fill-secondary-600';
    case 'success':
      return '!fill-positive-600';
    case 'warning':
      return '!fill-warning-600';
    case 'danger':
      return '!fill-negative-600';
    default:
      return '!fill-positive-600';
  }
};

const colorButton = (type: 'danger' | 'success' | 'info' | 'warning') => {
  switch (type) {
    case 'info':
      return 'text-secondary-600 hover:!bg-secondary-200 hover:text-secondary-600 active:!bg-secondary-200 active:text-secondary-600';
    case 'success':
      return '!text-positive-600 hover:!bg-positive-200 hover:text-positive-600 active:!bg-positive-200 active:text-positive-600';
    case 'warning':
      return 'text-warning-600 hover:bg-warning-200 hover:!text-warning-600 active:!bg-warning-200 active:text-warning-600';
    case 'danger':
      return '!text-negative-600 hover:!bg-negative-200 hover:text-negative-600 active:!bg-negative-200 active:text-negative-600';
    default:
      return 'text-positive-600 hover:!bg-positive-200 hover:text-positive-600 active:!bg-positive-200 active:text-positive-600';
  }
};
</script>
